import DiscussionList from "./DiscussionList"
import DiscussionListContainer from "./DiscussionListContainer"
import DiscussionListStartDiscussion from "./DiscussionListStartDiscussion"
import DiscussionListItem from "./item/DiscussionListItem"

export default {
  Container: DiscussionListContainer,
  List: DiscussionList,
  Item: DiscussionListItem,
  StartDiscussion: DiscussionListStartDiscussion
}
